import { useI18n } from '@cascade/react/i18n';
import { useProjects } from '@cascade/react/projects';
import { Tabs } from '@cascade/ui-library';
import type { TTabConfig } from '@cascade/ui-library';
import { AccountSettings } from './account-settings/index.ts';
import classes from './Settings.module.scss';
import { Page } from '#components/page/index.ts';
import { ProjectPicker } from '#components/project-picker/index.ts';
import { TagForm } from '#components/tag-form/index.ts';

export const Settings = () => {
  const { translate } = useI18n();
  const { canSelectProject, canEditTags } = useProjects();

  const accountTab: TTabConfig = {
    id: 'account',
    label: translate('settings.account.title'),
    iconType: 'user',
    content: <AccountSettings />,
  };

  const tagsTab: TTabConfig = {
    id: 'tags',
    label: translate('settings.tags.title'),
    iconType: 'tags',
    content: <TagForm />,
  };

  const projectTab: TTabConfig = {
    id: 'project',
    label: translate('settings.project.title'),
    iconType: 'robot',
    content: <ProjectPicker />,
  };

  const tabs = [
    ...(canSelectProject ? [projectTab] : []),
    ...(canEditTags ? [tagsTab] : []),
    accountTab,
  ];

  const tabIds = tabs.map((tab) => tab.id).join();

  return (
    <Page iconType='gear' title={translate('settings.title')}>
      <Tabs
        key={tabIds}
        variant='underline'
        tabs={tabs}
        contentClassName={classes.panel}
      />
    </Page>
  );
};
